import { actionGenerator, IReduxAction } from '../../utils/actions';

export const PUBLISH_OFFER = 'PUBLISH_INFO :: PUBLISH_OFFER';

export type TPublishOfferAction = IReduxAction<typeof PUBLISH_OFFER, IPublishOfferPayload>;

interface IPublishOfferPayload {
  isPremoderationSkip: boolean;
}

export const publishOffer = actionGenerator<typeof PUBLISH_OFFER, IPublishOfferPayload>(PUBLISH_OFFER);
